import { PixiAppRefs } from './types';

/**
 * Builds a stateful selection renderer that toggles the selected visual on the
 * connector and node entities. It diffs against the previously selected ids so
 * only the entities that changed are redrawn, keeping frequent interaction-state
 * updates (such as marquee moves) cheap.
 */
export function createSelectionRenderer(refs: PixiAppRefs): (selected: Set<string>) => void {
  let current = new Set<string>();

  const setSelected = (id: string, selected: boolean): void => {
    refs.connectorEntities.current.get(id)?.setSelected(selected);
    refs.nodeEntities.current.get(id)?.setSelected(selected);
  };

  return (next: Set<string>): void => {
    current.forEach(id => {
      if (!next.has(id)) {
        setSelected(id, false);
      }
    });
    next.forEach(id => {
      if (!current.has(id)) {
        setSelected(id, true);
      }
    });
    current = next;
  };
}
